import VideoConstructor from '@scripts/video';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules'


// Import Three.js
import * as THREE from "three";
import { OrbitControls } from "three/addons/controls/OrbitControls.js";
import { EffectComposer } from "three/addons/postprocessing/EffectComposer.js";
import { RenderPass } from "three/addons/postprocessing/RenderPass.js";
import { UnrealBloomPass } from "three/addons/postprocessing/UnrealBloomPass.js";
import { AfterimagePass } from "three/addons/postprocessing/AfterimagePass.js";
import { OutputPass } from "three/addons/postprocessing/OutputPass.js";

window.addEventListener('load', () => {
  // Glass effect to header on scroll
  const Header = document.querySelector('header');
  window.addEventListener('scroll', () => {
    Header.classList.toggle('glass', window.scrollY >= 80);
  });

  // Video constructor
  const videos = document?.querySelectorAll('video')
  videos.forEach(video => {
    VideoConstructor(video)
  })

  const Popup = document.querySelector('.popup');
  const Triggers = document.querySelectorAll('.btn-trigger');
  if (Popup && Triggers) {
  const PopupClose = Popup?.querySelector('.popup__close');
  const PopupWrapper = Popup?.querySelector('.popup__wrapper');
    PopupWrapper.onclick = (event) => {
      event.stopPropagation();
    }
    Popup.onclick = () => {
      Popup.classList.remove('open')
    }
    PopupClose.onclick = () => {
      Popup.classList.remove('open')
    }
    Triggers?.forEach((btn) => {
      btn.onclick = () => {
        Popup.classList.add('open')
      }
    })
  }

  const PopupCookies = document.querySelector('.popup--cookies');
  if (PopupCookies) {
    const PopupCookiesButton = PopupCookies?.querySelector('button');
    PopupCookiesButton.onclick = () => {
      PopupCookies.classList.remove('show');
    }
  }

  const Burger = document.querySelector('.btn-burger');
  Burger.onclick = () => {
    Burger.classList.toggle('active');
  }

  function TypingText(typo) {
    let typoText = typo.dataset.text
    let delay = typo.dataset.delay ? parseInt(typo.dataset.delay) : 0
    let i = 0
    typo.classList.add('active')
    typo.innerHTML = ''

    function TypeWriter() {
      if (i < typoText.length && typo.classList.contains('active')) {
        typo.innerHTML += typoText.charAt(i)
        i++
        setTimeout(TypeWriter, 36)
      }
    }
    setTimeout(() => TypeWriter(), delay)
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const block = entry.target;

        // Получаем кастомную задержку из data-delay
        // Если атрибута нет - используем значение по умолчанию (300ms)
        const delay = block.dataset.delay ? parseInt(block.dataset.delay) : 0;
        console.log(block.dataset.delay, delay)

        setTimeout(() => {
          entry.target.classList.add('show');
          let typoNodes = entry.target.querySelectorAll('.typing')
          typoNodes?.forEach(typoNode => TypingText(typoNode))
        }, delay)

        // Прекращаем наблюдение
        observer.unobserve(block);
      }
    });
  }, { threshold: .9 });

  document.querySelectorAll('.hiding').forEach(el => observer.observe(el));



  // Carousels

  const swiperPart1 = new Swiper('.StepsPart1 .swiper', {
    slidesPerView: 1,
    spaceBetween: 8,
    centeredSlides: true,
    initialSlide: 0,
    modules: [Navigation],
    navigation: {
      nextEl: '.StepsPart1 .right',
      prevEl: '.StepsPart1 .left',
    },
    breakpoints: {
      1000: {
        slidesPerView: 2,
        initialSlide: 0,
        centeredSlides: false
      },
      1200: {
        spaceBetween: 30,
        slidesPerView: 3,
        centeredSlides: false
      }
    }
  })
  const swiperPart2 = new Swiper('.StepsPart2 .swiper', {
    slidesPerView: 1,
    spaceBetween: 8,
    centeredSlides: true,
    initialSlide: 0,
    modules: [Navigation],
    navigation: {
      nextEl: '.StepsPart2 .right',
      prevEl: '.StepsPart2 .left',
    },
    breakpoints: {
      1000: {
        slidesPerView: 2,
        initialSlide: 0,
        centeredSlides: false
      },
      1200: {
        spaceBetween: 30,
        slidesPerView: 3,
        centeredSlides: false
      }
    }
  })
  const swiperPart3 = new Swiper('.StepsPart3 .swiper', {
    slidesPerView: 1,
    spaceBetween: 8,
    centeredSlides: true,
    initialSlide: 0,
    modules: [Navigation],
    navigation: {
      nextEl: '.StepsPart3 .right',
      prevEl: '.StepsPart3 .left',
    },
    breakpoints: {
      1000: {
        slidesPerView: 2,
        initialSlide: 0,
        centeredSlides: false
      },
      1200: {
        spaceBetween: 30,
        slidesPerView: 3,
        centeredSlides: false
      }
    }
  })

})
